export enum ButtonStyle {
    Default = "Default",
    NotAvailable = "NotAvailable",
    Inverse = "Inverse",
}

export enum ButtonSize {
    S = "S",
    M = "M",
    L = "L",
    XL = "XL",
}

export interface ButtonAppearance {
    style?: ButtonStyle,
    size?: ButtonSize,
    fullWidth?: boolean,
    disabled?: boolean,
    noShadow?: boolean,
    border?: boolean,
}

export interface ButtonControlValues {
    id: string,
    minQuantity: number,
    maxQuantity: number,
    currentQuantity: number,
    onChange: (quantity: number) => void,
}
